import { i18nKey } from "@shared";
const none = { kind: "none" };
/**
 * Blocking from a profile acts where the card was opened: the DM for a DM, the group for a group,
 * the community for a channel or community. Never for yourself or from a global context.
 */
export function profileBlock(input) {
    const { userId, chat, community } = input;
    if (input.isMe || input.inGlobalContext)
        return none;
    if (chat?.kind === "direct_chat") {
        return {
            kind: input.blockedUsers.has(userId) ? "unblock" : "block",
            context: { kind: "direct_chat" },
        };
    }
    if (chat?.kind === "group_chat") {
        if (!input.canBlockUsers(chat.id))
            return none;
        return {
            kind: input.blockedChatUsers.has(userId) ? "unblock" : "block",
            context: { kind: "group_chat", id: chat.id },
        };
    }
    if (community !== undefined) {
        if (!input.canBlockUsers(community.id))
            return none;
        return {
            kind: input.blockedCommunityUsers.has(userId) ? "unblock" : "block",
            context: { kind: "community", id: community.id },
        };
    }
    return none;
}
/** The toast for a block or unblock that succeeded or failed. */
export function blockOutcome(blocking, success) {
    const action = blocking ? "block" : "unblock";
    return success
        ? { kind: "success", message: i18nKey(`${action}UserSucceeded`) }
        : { kind: "failed", message: i18nKey(`${action}UserFailed`) };
}
